import { AnalyticsBrowser } from '@segment/analytics-next'

declare global {
  interface Window {
    analytics: AnalyticsBrowser
  }
}

export const analytics = window.analytics

export const SegmentAnalyticsProvider = (props: React.PropsWithChildren) => props.children

// Same API as segment.tsx so shared code has no platform checks. Web Segment is still
// loaded by the snippet in public/index.html and has no Customer.io SDK, so these keep
// today's behaviour.
export const isSegmentInitialized = () => true

export const getSegmentClient = () => window.analytics as AnalyticsBrowser

export async function initSegment(_options: { cioAnonymousId: string | null }) {
  return getSegmentClient()
}

export async function setSegmentCioAnonymousId(_id: string | null) {
  return
}
